import React from 'react';
import { useUser } from '@sde/widgets-core/src/redux/resources/user';
import { AuthenticateUser } from '@sde/widgets-core/src/widgets/AuthenticateUser';

export const AuthenticateUserWidget = () => {
  const { updateUser } = useUser.actions();

  const widgetProps = {
    events: {
      onSuccess: updateUser,
    },
  };

  return <AuthenticateUser {...widgetProps} />;
};
